<template>
  <!------ Pay Modal ---------->
  <div
    class="modal fade"
    id="returnOrderProductModal"
    tabindex="-1"
    aria-labelledby="returnOrderProductModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">RETURN {{ selectedOrderProduct.name }}</h5>
          <button
            type="button"
            class="close"
            @click="hideModal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="selectedOrderProduct">
            <div class="form-group">
              <label>Quantity to return</label>
              <input
                type="number"
                min="1"
                :max="selectedOrderProduct.quantity"
                v-model.number="quantityToReturn"
                class="form-control"
                placeholder="Enter quantity"
              />
              <small class="text-muted d-block mt-1">
                Remaining: {{ remainingQty }}
              </small>
            </div>

            <!-- <div class="form-group mt-3">
              <label>Note (optional)</label>
              <a-textarea
                v-model:value="returnNote"
                show-count
                :maxlength="50"
                placeholder="e.g. Partial payment from balance"
              />
            </div> -->

            <div class="summary mt-4">
              <b>Summary</b>
              <p>
                {{ quantityToReturn }} unit(s) × ₦{{
                  Number(selectedOrderProduct.unit_value) +
                  Number(selectedOrderProduct.price)
                }}
                =
                <b
                  >₦{{
                    quantityToReturn *
                    (Number(selectedOrderProduct.unit_value) +
                      Number(selectedOrderProduct.price))
                  }}</b
                >
              </p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            class="btn btn-submit"
            @click="checkAccess"
            :disabled="loading"
          >
            <template v-if="!loading">
              <span id="btntext">Return</span>
            </template>
            <template v-else>
              <i class="fas fa-spinner fa-spin me-2"></i> Returning...
            </template>
          </button>

          <button class="btn btn-cancel" @click="hideModal" :disabled="loading">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!------ End Pay Modal ---------->
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "OrderProductReturnModal",
  data() {
    return {
      // Define reactive data here:
      quantityToReturn: null,
      returnNote: "",
      loading: false,
      access_code: null,
      newSaleReturn: {
        order_ref: null,
        products: [],
      },
    };
  },
  props: {
    selectedOrderProduct: {
      type: Object,
      default: null,
    },
    order_ref: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState({
      adminPermissions: "adminPermissions",
    }),
    ...mapGetters({
      formatAmount: "formatAmount",
      hasAccess: "hasAccess",
    }),

    remainingQty() {
      if (this.selectedOrderProduct) {
        return (
          Number(this.selectedOrderProduct.ordered_quantity) -
          (Number(this.selectedOrderProduct.total_paid_qty) +
            Number(this.selectedOrderProduct.returned_quantity))
        );
      }
      return 0;
    },
  },
  methods: {
    ...mapActions({
      _addSaleReturn: "saleReturn/add",
      _showOtpDialog: "showOtpDialog",
      _sendAccessCode: "accessCode/add",
    }),
    hideModal() {
      $("#returnOrderProductModal").modal("hide");
    },

    verifyOtp() {
      this._showOtpDialog({
        title: "Enter Authorization Code",
        description: "Authorization Code Sent to the Supervisor!",
      }).then((response) => {
        this.access_code = response.value;
        // get the access code
        if (this.access_code != null) {
          this.returnOrderProduct();
        } else {
          Swal.fire("You need the Authorization Code");
        }
      });
    },
    async checkAccess() {
      let adminPermissions = this.adminPermissions;
      if (adminPermissions.length > 0) {
        // check if the user is the super admin
        if (this.hasAccess("create-sales-return")) {
          this.returnOrderProduct();
        } else {
          this._sendAccessCode({
            permission_code: "create-sales-return",
            item_id: this.newSaleReturn.order_ref,
            item_type: "reference",
          }).then((response) => {
            this.verifyOtp();
          });
          $("#returnOrderProductModal").modal("hide");
          Swal.fire({
            title: "Sending Authorization Code To Supervisor",
            html: `<div class="spinner-border text-dark" role="status"></div>`,
            closeOnClickOutside: false,
            buttons: false,
          });
        }
      }
    },
    returnOrderProduct() {
      if (this.validate()) {
        this.newSaleReturn.products.push({
          id: this.selectedOrderProduct.id,
          qty: this.quantityToReturn,
        });

        this._addSaleReturn({
          payload: {
            access_code: this.access_code,
            order_ref: this.newSaleReturn.order_ref,
            products: this.newSaleReturn.products,
          },
        })
          .then((response) => {
            Swal.fire("Sale Return Added", "", "success");
            $("#returnOrderProductModal").modal("hide");
            this.$router.push({ name: "salesreturnlist" });
          })
          .catch((error) => {
            Swal.fire(error.response.data.message, "", "error");
          });
      }
    },

    validate() {
      let error = "";
      let data = this.newSaleReturn;
      if (
        this.quantityToReturn < 1 ||
        this.quantityToReturn > this.remainingQty
      ) {
        error = `Please enter a quantity between 1 and ${this.remainingQty}`;
      }
      if (data.order_ref == null) {
        error = "Enter the Order Reference";
      }

      if (error) {
        Swal.fire({
          title: error,
          icon: "warning",
        });
        return false;
      } else {
        return true;
      }
    },
  },

  watch: {
    //     quantityToReturn: {
    //       handler(newValue) {
    //         if (newValue < 1) {
    //           this.quantityToReturn = 1;
    //         } else if (
    //           this.selectedOrderProduct &&
    //           newValue > this.selectedOrderProduct.quantity
    //         ) {
    //           this.quantityToReturn = this.selectedOrderProduct.quantity;
    //         }
    //       },
    //       immediate: true,
    //     },

    selectedOrderProduct: {
      handler(newValue) {
        if (newValue) {
          this.newSaleReturn.order_ref = this.order_ref;
          this.quantityToReturn = 1;
        }
      },
      immediate: true,
    },
  },
};
</script>
